angular.module('manufacturing', ['core', 'files', 'document'])
    .factory('ManufacturingOrder', function ($resource) {
        return $resource('/crm/api/manufacturing-order/:id', {id: "@id"}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/manufacturing-order/table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/manufacturing-order/table-statistics'},
            dashboard: {method: 'GET', isArray: false, url: '/crm/api/manufacturing-order/dashboard'},
            calendarItems: {method: 'GET', isArray: true, url: '/crm/api/manufacturing-order-calendar/items'},
            batch: {method: 'POST', isArray: true, url: '/crm/api/manufacturing-order/batch'},
            vehicleConflict: {method: 'GET', url: '/crm/api/manufacturing-order/vehicle-conflict'},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            action: {method: 'PUT', url: '/crm/api/manufacturing-order/:id/:action', params: {id: "@id", action: "@action"}},
            changeStatus: {method: 'POST', url: '/crm/api/manufacturing-order/:id/status', params: {id: "@id"}},
            acceptance: {method: 'POST', url: '/crm/api/manufacturing-order/:id/:resource', params: {id: "@id", resource: "@resource"}},
            link: {method: 'POST', url: '/crm/api/manufacturing-order/:id/links', params: {id: "@id"}},
            unlink: {method: 'DELETE', url: '/crm/api/manufacturing-order/:id/links/:relatedOrderId', params: {id: "@id", relatedOrderId: "@relatedOrderId"}},
        });
    })
    .service('ManufacturingOrderVehicleConflictService', function ($q, ManufacturingOrder) {
        this.check = (vehicle, deliveryTime, excludedOrderId) => {
            const interval = vehicle && vehicle.manufacturingSettings && vehicle.manufacturingSettings.minimumOrderIntervalMinutes
            if (!vehicle || !vehicle.id || !deliveryTime || !interval) return $q.when(null)
            return ManufacturingOrder.vehicleConflict({vehicleId: vehicle.id, deliveryTime: moment(deliveryTime).format(), excludedOrderId: excludedOrderId}).$promise.then(result => result.conflict ? result : null)
        }
    })
    .component('manufacturingOrderVehicleConflict', {
        bindings: {conflict: '<'},
        template: '<div class="manufacturing-order-notice manufacturing-order-notice--warning" ng-if="$ctrl.conflict" role="alert"><span class="manufacturing-order-notice__icon"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span><span class="manufacturing-order-notice__content"><strong>Konflikt terminu pojazdu</strong><small>{{$ctrl.conflict.message}}</small></span></div>'
    })
    .service('ManufacturingOrderService', function ($rootScope, modals, ManufacturingOrder, VehicleLocation) {
        this.statuses = () => ['PENDING', 'CONFIRMED', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED']
        this.add = (properties = {}, linkToOrderId) => {
            const open = () => modals.open('app/manufacturing/edit-modal.html', 'ManufacturingOrderEditController', {properties: properties, linkToOrderId: linkToOrderId}, {size: "md"}, "$ctrl")
            if(properties.location != null && typeof properties.location !== 'object'){
                return VehicleLocation.get({id: properties.location}).$promise.then(item => properties.location = item).then(open)
            }
            return open()
        }
        const cloneProperties = item => ({
            client: item.client,
            deliveryAddress: item.deliveryAddress,
            location: item.location,
            nodes: item.nodes,
            notes: item.notes,
            product: item.product,
            quantityOrdered: item.quantityOrdered,
            technologyRequirements: angular.copy(item.technologyRequirements),
            transport: item.transport
        })
        this.clone = item => this.add(cloneProperties(item))
        this.cloneAndLink = item => {
            const properties = angular.extend(cloneProperties(item), {deliveryTime: item.deliveryTime})
            delete properties.location
            delete properties.nodes
            return this.add(properties, item.id)
        }
        this.addBatch = properties => modals.open('app/manufacturing/batch-edit-modal.html', 'ManufacturingOrderBatchEditController', {properties: properties}, {size: "lg"}, "$ctrl")
        this.open = (id) => {
            return modals.open('app/manufacturing/show-modal.html', 'ManufacturingOrderShowController', {id: id}, {size: "lg"}, "$ctrl")
        }
        this.edit = (id, properties) => {
            return modals.open('app/manufacturing/edit-modal.html', 'ManufacturingOrderEditController', {id: id, properties: properties}, {size: "lg"}, "$ctrl")
        }
        this.delete = item => {
            return modals.confirmDelete(item.id, () => ManufacturingOrder.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('manufacturing-order.deleted')))
        }
        this.action = (id, action) => {
            return ManufacturingOrder.action({id: id, action: action}).$promise.then(() => $rootScope.$broadcast('manufacturing-order.updated'))
        }
        this.processQuantity = (id, product_id) => {
            return modals.open('app/manufacturing/process-quantity.html', 'ManufacturingOrderProcessQuantityController', {id: id, product_id: product_id}, {size: "md"}, "$ctrl");
        }
        this.changeStatus = (id, status) => {
            return modals.open('app/manufacturing/change-status.html', 'ManufacturingOrderChangeStatusController', {id: id, status: status}, {size: "md"}, "$ctrl")
        }
        this.showRealisationHistory = (orderId) => {
            return modals.open('app/manufacturing/realisation-history.html', 'ManufacturingOrderRealisationHistoryController', {id: orderId}, {size: "lg"}, "$ctrl")
        }
        this.link = orderId => ManufacturingOrder.get({id: orderId}).$promise.then(order => {
            const alreadySelectedIds = (order.linkedOrders || []).map(item => item.id).concat(order.id)
            return modals.open('app/manufacturing/link-select-modal.html', 'ManufacturingOrderLinkSelectController', {alreadySelectedIds: alreadySelectedIds, client: order.client}, {size: "lg"}, "$ctrl")
                .then(selected => ManufacturingOrder.link({id: order.id}, {orderId: selected.id}).$promise)
                .then(() => $rootScope.$broadcast('manufacturing-order.updated'))
        })
        this.unlink = (orderId, relatedOrderId) => modals.confirm('Czy na pewno odwiązać zamówienie <strong>' + relatedOrderId + '</strong>?', () => ManufacturingOrder.unlink({id: orderId, relatedOrderId: relatedOrderId}).$promise.then(() => $rootScope.$broadcast('manufacturing-order.updated')))
        this.showHelp = () => {
            return modals.open('app/manufacturing/help-modal.html', 'ManufacturingOrderHelpController', {}, {size: "md"}, "$ctrl");
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_MANUFACTURING_ORDER_MODULE",
            path: "/manufacturing-order-calendar",
            ico: "fa fa-fw fa-circle-o-notch fa-spin",
            name: 'manufacturing-order.menu',
            order: 80
        });
    })
    .config(function ($stateProvider) {
        $stateProvider.state('manufacturingOrderList', {
            parent: 'app',
            url: '/manufacturing-order?{page:int}&{size:int}&sort&search&startDate&endDate&realisationStartDate&realisationEndDate&status&type&user&manager&filter&customFilter&{location:int}&client&{fiberType:int}&{showInCalendar:boolean}&groupName',
            data: {
                authorities: ['ROLE_MANUFACTURING_ORDER_MODULE']
            },
            params: {
                status: {array: true, squash: false},
                customFilter: {array: true, value: [], squash: false},
            },
            views: {
                'content@': 'manufacturingOrderList'
            },
            resolve: {
                statistics: (ManufacturingOrder, $stateParams) => ManufacturingOrder.tableStatistics($stateParams).$promise,
                filters: ($stateParams) => angular.copy($stateParams),
                page: (ManufacturingOrder, $stateParams) => ManufacturingOrder.table($stateParams).$promise
            }
        })
    })
    .service('FilterStorageService', function($window) {
        const TTL_DAYS = 7;
        const MS_IN_DAY = 24 * 60 * 60 * 1000;

        function isExpired(timestamp) {
            return (Date.now() - timestamp) > TTL_DAYS * MS_IN_DAY;
        }

        this.load = function(key) {
            const raw = $window.localStorage.getItem(key);
            if (!raw) return null;

            try {
                const parsed = JSON.parse(raw);
                if (parsed.timestamp && !isExpired(parsed.timestamp)) {
                    return parsed.filters;
                }
            } catch (e) {
                console.warn('Invalid localStorage content for key', key, e);
            }
            return null;
        };

        this.save = function(key, filters) {
            $window.localStorage.setItem(key, JSON.stringify({
                filters: filters,
                timestamp: Date.now()
            }));
        };

        this.clear = function(key) {
            $window.localStorage.removeItem(key);
        };

        this.hasUrlFilters = function (params) {
            return Object.keys(params).some(k => params[k] !== null && params[k] !== undefined && params[k] !== '');
        }
    });
